<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 137.205 55.6">
    <g id="Van" transform="translate(10739.464 253.552)">
      <path id="Path_87084" data-name="Path 87084"
        d="M46.85,256.373a9.479,9.479,0,1,0,9.477,9.477,9.486,9.486,0,0,0-9.477-9.477m0,16.878a7.4,7.4,0,1,1,7.4-7.4,7.408,7.408,0,0,1-7.4,7.4"
        transform="translate(-10670.144 -473.282)" :fill="themeColor" />
      <path id="Path_87085" data-name="Path 87085"
        d="M17.909,256.373a9.477,9.477,0,1,0,9.477,9.477,9.486,9.486,0,0,0-9.477-9.477M23.15,271.08a7.357,7.357,0,0,1-5.236,2.171h-.006a7.4,7.4,0,0,1,0-14.8h.006a7.4,7.4,0,0,1,5.236,12.63"
        transform="translate(-10723.866 -473.282)" :fill="themeColor" />
      <path id="Path_87086" data-name="Path 87086"
        d="M137.218,288.97c-.834-7.2-3.148-16.549-6.927-19.208a76.224,76.224,0,0,0-15.2-6.587c-2.722-.977-5.241-1.879-6.926-2.631-2.091-.914-5.924-3.068-9.98-5.35a164.041,164.041,0,0,0-16.875-8.729c-15.235-5.872-68.637-1.085-69.174-1.037l-.374.034-.023-.009-4.4.326a1.039,1.039,0,0,0,.091,2.074l3.008-.22L3.155,264.243a1.056,1.056,0,0,0-.086.383l-.457,11.679L.181,280.047a1.018,1.018,0,0,0-.117.854c1.682,5.7,5.016,9.232,8.695,9.232h8.135c.243-.134.54-.109.737-.3a1.026,1.026,0,0,0,.306-.734,1.044,1.044,0,0,0-1.04-1.042H8.759c-2.414,0-4.839-2.528-6.324-6.6l-.246-.671L4.52,277.2a1.031,1.031,0,0,0,.169-.526l.574-12.031,7.532-17.183.848-.071c8.846-.726,53.638-4.082,67,1.057A165.494,165.494,0,0,1,97.2,257.04c2.328,1.305,4.473,2.5,6.33,3.5l5.03,2.7-90.987-.317a1.035,1.035,0,0,0-.725.3,1.04,1.04,0,0,0,.734,1.774l97.639.411a79.127,79.127,0,0,1,13.742,5.967c3.707,2.6,5.715,13.744,6.187,17.829a1.038,1.038,0,0,0,.911.911h.123a1.094,1.094,0,0,0,.814-.391,1.041,1.041,0,0,0,.217-.766"
        transform="translate(-10739.483 -497.096)" :fill="themeColor" />
      <path id="Path_87087" data-name="Path 87087"
        d="M67.11,261.206h0a1.034,1.034,0,0,0,1.04-1.037,1.044,1.044,0,0,0-1.034-1.045h-48.8a1.041,1.041,0,0,0,.006,2.082Z"
        transform="translate(-10707.433 -468.175)" :fill="themeColor" />
    </g>
  </svg>

</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
